<button class="btn link" (click)="toggleSubAccounts()">
    {{ showSubAccounts ? 'Hide individual accounts' : 'Show individual accounts' }}
</button>
<div *ngIf="showSubAccounts">
    <dl
        *ngIf="{
            accounts: accounts$ | async,
            issuers: issuers$ | async
        } as meta"
        @list
    >
        <div
            *ngFor="
                let account of dataElements
                    | sbSubAccounts : meta.accounts : meta.issuers;
                trackBy: trackByFn
            "
            @slideInOut
            class="sb-group"
        >
            <div class="sb-group-thumbnail">
                <sb-company-logo
                    [companyWebsite]="account.issuer?.metadata?.website"
                    [companyLogoUrl]="account.issuer?.metadata?.logoUrl"
                    [countryCode]="account.issuer?.metadata?.countryCode | countryCode"
                ></sb-company-logo>
            </div>
            <dt class="sb-group-name">
                <a [routerLink]="[]" [queryParams]="{ accountIds: account.id }">
                    {{ account.name }}
                </a>
            </dt>
            <dd class="sb-group-details">
                <span *ngIf="account.name !== account.accountNumber">
                    {{ account.accountNumber }}
                </span>
            </dd>
            <dd class="sb-group-balance">
                <sb-animated-number
                    [ccy]="account.currency"
                    [useMonotypeFont]="false"
                    [value]="account.balance"
                ></sb-animated-number>
            </dd>
            <dd
                class="sb-group-performance d-inline-flex align-items-center justify-content-end text-nowrap"
                *ngIf="account.relativeDailyPerformance as performance"
            >
                Daily&nbsp;
                <span
                    style="display: contents"
                    [class.text-positive]="performance > 0"
                    [class.text-negative]="performance < 0"
                >
                    <tabler-icon
                        style="height: 18px; width: 18px"
                        name="circle-arrow-up"
                        [class.sb-transform-r90]="performance === 0"
                        [class.sb-transform-r45]="performance > 0"
                        [class.sb-transform-r135]="performance < 0"
                        class="me-1 tabler-fill-circle sb-transform-animate sb-icon-sm"
                    ></tabler-icon>
                    <sb-animated-number
                        class="font-weight-medium"
                        [useMonotypeFont]="false"
                        formatStyle="percent"
                        [value]="performance"
                    ></sb-animated-number>
                </span>
            </dd>
        </div>
    </dl>
</div>
